<template>
  <el-card
    v-if="element"
    :body-style="{ padding: '1rem 0' }"
    style="margin: 1rem 1rem 1rem 1rem"
    shadow="never"
  >
    <VuePerfectScrollbar
      class="d-flex flex-column p-5"
      style="height: calc(100vh - 11.7rem)"
    >
      <div class="pt-5 pt-5" id="invoice">
        <div class="d-flex flex-row">
          <div class="d-flex flex-column col-4 p-0">
            <div>
              <img src="/static/image/Gpuhub-logo-text.svg" height="30" />
            </div>
            <div class="invoice-title-large mt-3">Account number</div>
            <div class="invoice-text-normal">{{ user.username }}</div>
            <div class="invoice-text-normal mt-3">
              <div class="invoice-title-large">Bill to Address</div>
              <div>Name:&nbsp;&nbsp;&nbsp;{{ element.billingName }}</div>
              <div>Address:&nbsp;&nbsp;&nbsp;{{ element.billingAddress }}</div>
              <div>Phone:&nbsp;&nbsp;&nbsp;{{ element.billingPhone }}</div>
              <div>Tax code:&nbsp;&nbsp;&nbsp;{{ element.billingTaxCode }}</div>
            </div>
          </div>
          <div class="flex-fill">
            <div class="invoice-title-large">iRender , Jsc. Invoice</div>
            <div
              style="border-bottom: 2px solid #42a5f5"
              class="invoice-text-normal mt-1"
            >
              Email or talk to us about your iRender account or bill, visit
              https://irendering.net/
            </div>
            <div
              style="border-bottom: 1px solid #42a5f5"
              class="invoice-title-large mt-2"
            >
              Invoice Summary
            </div>
            <div
              style="border-bottom: 1px solid #42a5f5"
              class="invoice-text-normal mt-2"
            >
              <div class="d-flex justify-content-between">
                <div>Invoice number</div>
                <div>
                  <span>{{ element.transactionId }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-between mt-1">
                <div>Invoice Date</div>
                <div>{{ element.lastModifiedAt | DateTime }} UTC</div>
              </div>
            </div>
            <div
              style="border-bottom: 2px solid #42a5f5"
              class="d-flex justify-content-between mt-2"
            >
              <div class="invoice-title-large">TOTAL PAYMENT AMOUNT</div>
              <div class="invoice-title-large">
                <span v-if="element.amount">
                  <span>{{ element.amount }}</span>
                  <span>&nbsp;$</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div
            style="font-weight: 400; color: #212121"
            class="invoice-text-large"
          >
            This invoice is for invoice ID:
            <span>{{ element.transactionId }}</span>
          </div>
          <div class="invoice-text-normal">
            Greetings from iRender Services, we're writing to provide you with
            an electronic invoice for your use of iRender services. Additional
            information about your bill, individual service charge details, and
            your account history are available on the Billing Page.
          </div>
        </div>
        <div class="mt-5">
          <div style="border: 2px solid #90caf9">
            <div class="cell title-table">Summary</div>
            <div class="cell">
              <div class="title-service">iRender Charges</div>
              <div class="invoice-text-normal">
                <span v-if="element.amount">
                  <span>{{ element.amount }}</span>
                  <span>&nbsp;$</span>
                </span>
              </div>
            </div>
            <div class="invoice-text-normal">
              <div class="cell">
                <div class="title-details">Payment method</div>
                <div>
                  <span v-if="element.paymentMethodDescription">
                    <span>{{ element.paymentMethodDescription }}</span>
                  </span>
                </div>
              </div>
              <div class="cell">
                <div class="title-details">Charges</div>
                <div>
                  <span v-if="element.amount">
                    <span>{{ element.amount }}</span>
                    <span>&nbsp;$</span>
                  </span>
                </div>
              </div>
              <div class="cell">
                <div class="title-details">Credits</div>
                <div>
                  <span>0</span>
                  <span>&nbsp;$</span>
                </div>
              </div>
              <div class="cell">
                <div class="title-details">Tax</div>
                <div>
                  <span>0</span>
                  <span>&nbsp;$</span>
                </div>
              </div>
              <div style="background-color: #fff3e0" class="cell">
                <div class="title-total">Total for this invoice</div>
                <div>
                  <span v-if="element.amount">
                    <span>{{ element.amount }}</span>
                    <span>&nbsp;$</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5" style="border: 2px solid #90caf9">
            <div class="cell title-table">Detail</div>
            <div class="cell">
              <div class="title-service">
                <span>iRender Point</span>
              </div>
              <div class="invoice-text-normal">
                <span v-if="element.amount">
                  <span>{{ element.amount }}</span>
                  <span>&nbsp;$</span>
                </span>
              </div>
            </div>
            <div class="invoice-text-normal">
              <div class="cell">
                <div class="title-details">Exchange rate</div>
                <div>
                  <span>1 $ (US Dollar) = 1 iRp (iRender point)</span>
                </div>
              </div>
              <div class="cell">
                <div class="title-details">iRender point</div>
                <div>
                  <span>{{ element.irenderPoint }} iRp</span>
                </div>
              </div>
              <div class="cell">
                <div class="title-details">Bonus point</div>
                <div>
                  <span>{{ element.bonusPoint }} Bp</span>
                </div>
              </div>
              <div class="cell">
                <div class="title-details">Charges</div>
                <div>
                  <span v-if="element.amount">
                    <span>{{ element.amount }}</span>
                    <span>&nbsp;$</span>
                  </span>
                </div>
              </div>
              <div class="cell">
                <div class="title-details">VAT</div>
                <div>
                  <span>0</span>
                  <span>&nbsp;$</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="invoice-text-small d-flex flex-row"
          style="margin-top: 2.5rem"
        >
          <div class="col-7 p-0">
            <div>
              † The amount of your actual charges for this statement period may
              differ from the charges shown on this page. The charges shown on
              this page do not include any additional usage charges accrued
              during this statement period after the date you are viewing this
              page. Also, one-time fees and subscription charges are assessed
              separately, on the date that they occur.
            </div>
            <div>All charges and prices are in US Dollars</div>
            <div>
              All Render Farm Services are sold by iRender Services, Jsc.
            </div>
          </div>
          <div class="col-2"></div>
          <div class="col-3 p-0">
            <div>Service Provider:</div>
            <div>(Not to be used for payment remittance)</div>
            <div>iRender Services, Jsc.</div>
            <div>No.5, 82 Lane, Dich Vong Hau, Cau Giay, Ha Noi</div>
            <div>Ha Noi , HN 100000 , VN</div>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
  </el-card>
</template>

<script>
// CSS
import "@/assets/css/invoice.scss";

//Lib
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  props: {
    element: {
      type: Object,
      default(){
        return {};
      },
    },
  },

  mounted() {},
};
</script>